/* IZURO product recommendation scroller. Supports Shopify's lazy-loaded recommendations. */
if (!customElements.get('izuro-related-carousel')) {
  class IzuroRelatedCarousel extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-related-track]');
      if (!track || this._izuroReady) return;
      this._izuroReady = true;
      this.track = track;
      this.controls = this.querySelector('[data-related-controls]');
      this.prev = this.querySelector('[data-related-prev]');
      this.next = this.querySelector('[data-related-next]');
      this.onScroll = () => this.updateControls();
      this.onPrev = () => this.slide(-1);
      this.onNext = () => this.slide(1);
      track.addEventListener('scroll', this.onScroll, { passive: true });
      this.prev?.addEventListener('click', this.onPrev);
      this.next?.addEventListener('click', this.onNext);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', this.onScroll);
      }
      this.updateControls();
      requestAnimationFrame(() => this.updateControls());
    }
    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      this.resizeObserver?.disconnect();
      if (!this.resizeObserver) window.removeEventListener('resize', this.onScroll);
      this._izuroReady = false;
    }
    slide(direction) {
      const first = this.track.querySelector('.izuro-related-item');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = first ? first.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: direction * step * Math.max(1, Math.floor(this.track.clientWidth / step)), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    updateControls() {
      if (!this.track || !this.controls) return;
      const overflow = this.track.scrollWidth > this.track.clientWidth + 3;
      this.controls.hidden = !overflow;
      if (this.prev) this.prev.disabled = this.track.scrollLeft < 3;
      if (this.next) this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 3;
    }
  }
  customElements.define('izuro-related-carousel', IzuroRelatedCarousel);
}
